import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login.vue'
import store from '@/store'

Vue.use(VueRouter)

const IfAuthMiddleware = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    return next({ path: '/' })
  }

  return next()
}

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'Dashboard' },
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: IfAuthMiddleware
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/views/ChangePassword.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('@/views/ForgotPassword.vue')
  },
  {
    path: '/reset-password/:token',
    name: 'resetPassword',
    component: () => import('@/views/ResetPassword.vue')
  },
  {
    path: '/quotation/create',
    name: 'Quotation',
    component: () => import('@/views/Quotation.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/quotation/:id',
    name: 'QuotationDetail',
    component: () => import('@/views/Quotations/Detail.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/booking/:id',
    name: 'Booking',
    component: () => import('@/views/Booking.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/quotations',
    name: 'Quotations',
    component: () => import('@/views/Quotations.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/suppliers',
    name: 'Suppliers',
    component: () => import('@/views/Suppliers/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/suppliers/create',
    name: 'CreateSupplier',
    component: () => import('@/views/Suppliers/CreateSuppliers.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/suppliers/:id/edit',
    name: 'EditSupplier',
    component: () => import('@/views/Suppliers/EditSuppliers.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/aforders',
    name: 'Aforders',
    component: () => import('@/views/Aforders/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/aforders/:aforder',
    name: 'AfordersShow',
    component: () => import('@/views/Aforders/ShowAforderIndex.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/Blog/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/logicoins',
    name: 'Logicoins',
    component: () => import('@/views/Logicoins/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/invoicing',
    name: 'Invoicing',
    component: () => import('@/views/Invoicing/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/webhooks',
    name: 'Webhooks',
    component: () => import('@/views/Webhooks/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/webhooks/:id/history/:name',
    name: 'WebhooksHistory',
    component: () => import('@/views/Webhooks/History.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/groups',
    name: 'Groups',
    component: () => import('@/views/Groups/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/Users/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/users/create',
    name: 'UsersCreate',
    component: () => import('@/views/Users/CreateUsers.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/users/:id/edit',
    name: 'UsersEdit',
    component: () => import('@/views/Users/EditUsers.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/old-bookings',
    name: 'OldBookings',
    component: () => import('@/views/OldBookings/Index.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/old-bookings/:aforder',
    name: 'OldBookingsShow',
    component: () => import('@/views/OldBookings/ShowOldBookings.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/user/change-password',
    name: 'UserChangePassword',
    component: () => import('@/views/Users/ChangePassword.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '/notify-of-privacy',
    name: 'NotifyOfPrivacy',
    component: () => import('@/views/NotifyOfPrivacy.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: () => import('@/views/TermsAndConditions.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('@/views/Notifications/NotificationsView'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/views/Support.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/financials/carta-porte/:aforder/create',
    name: 'CreateCartaPorte',
    component: () => import('../views/Financials/CartaPorte/Create.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/financials/carta-porte/:aforder/edit/:id',
    name: 'EditCartaPorte',
    component: () => import('../views/Financials/CartaPorte/Edit.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/test-map',
    name: 'Map',
    component: () => import('@/views/Map.vue'),
    meta: {
      requiresAuth: true,
      requiresTermsAndConditions: true
    }
  },
  {
    path: '*',
    redirect: { name: 'Home' }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes
})

// Middleware for check if user has logged
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }

    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router
